export default __webpack_public_path__ + "static/media/cz_binance.465f0032.jpeg";